import mockWidgetDataConfig from '../../utils/config/mockWidgetDataConfig';
import { safeJsonParse } from '../../utils/string/safeJsonParse';
import useSelectData from '../data/useSelectData';
import Cookies from 'js-cookie';


export function useWidgetInfo(reportId, reportName) {
  const widgetData = useSelectData({
    selectValues: `"id", "WIDGET_NAME", "WIDGET_TYPE", "WIDGET_AGG", "WIDGET_FIELD", "WIDGET_PARAMS"`,
    tableName: "reports.reports_widgets",
    whereField: "REPORT_ID",
    whereValue: reportId,
    orderby: "id asc",
  });

  const effectiveWidgetData = Cookies.get("cp-role") == 13
    ? mockWidgetDataConfig(reportName)
    : widgetData;

  const widgetInfo = effectiveWidgetData.map((row) => ({
    name: row.WIDGET_NAME,
    type: row.WIDGET_TYPE,
    agg: row.WIDGET_AGG,
    field: row.WIDGET_FIELD,
    params: safeJsonParse(row.WIDGET_PARAMS),
  }));

  return widgetInfo;
}
